<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </template>
      <v-layout row wrap white text-xs-center style="width:300px" py-3>
        <v-flex xs12 my-1>
          <div v-if="isLoggedIn">
            <ShareCodeEntryControl />
          </div>
        </v-flex>
        <v-flex xs12 my-1>
          <router-link :to="{ path: '/' }">
            <v-btn
              flat
              large
            >
              Manipulatives
            </v-btn>
          </router-link>
        </v-flex>
        <v-flex xs12 my-1>
          <router-link :to="{ path: '/resources' }">
            <v-btn
              flat
              large
            >
              Resources
            </v-btn>
          </router-link>
        </v-flex>
        <v-flex xs12 my-1>
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/webinars"
            target="_blank"
            v-if="isTeacher"
          >
            Webinars
          </v-btn>
        </v-flex>
        <v-flex xs12 my-1>
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/pricing"
            target="_blank"
            v-if="isTeacher"
          >
            Pricing
          </v-btn>
        </v-flex>
      </v-layout>
    </v-menu>
  </div>
</template>

<script>
import ShareCodeEntryControl from '@/components/ShareCodeEntryControl'

export default {
  components: {
    ShareCodeEntryControl
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.token !== null
    },
    isTeacher: function () {
      if (this.$store.getters.role) {
        return this.$store.getters.role === 'teacher';
      }
      return false;
    }
  }
}
</script>

<style scoped>
.logo {
  cursor: pointer;
}

.lg {
  font-size: 14px;
  color: #56544d;
  font-weight: 500;
  text-transform: uppercase;
}
</style>